import React, { FC } from 'react';

interface Props {
  severity: string;
  message: string;
}

const Message: FC<Props> = ({ severity, message }) => {
  const classname = () => {
    if (severity === 'error') {
      return `bg-ag_color-error`;
    } else if (severity === 'success') {
      return `bg-ag_color-success`;
    } else if (severity === 'info') {
      return `bg-ag_color-info`;
    } else {
      return `bg-ag_color-warning`;
    }
  };

  return (
    <div className={`${classname()} relative mb-18 py-15 pl-50 pr-15 text-sm font-light text-white`}>
      {severity === 'error' && <i className="icon icon-pricematch absolute ml-[-32px] text-24 !font-light"></i>}
      {severity === 'info' && <i className="icon icon-trophy-1 absolute ml-[-32px] text-24 !font-light"></i>}
      {severity === 'warning' && <i className="icon icon-trophy-1 absolute ml-[-32px] text-24 !font-light"></i>}
      {severity === 'success' && <i className="icon icon-check absolute ml-[-32px] text-24 !font-light"></i>}
      <span>{message}</span>
    </div>
  );
};

export default Message;
